import { Deserializable } from '../deserializable';
export class Fia implements Deserializable{

    public id:number;
    public userId: number;
    public plannedInvestmentDate: Date;
    public fiaAmount: number;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
      }
}
